import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DataService {

    private _username = new BehaviorSubject<string>("");
    username = this._username.asObservable();

    private _wallet = new BehaviorSubject<number>(0);
    wallet = this._wallet.asObservable();

    private _loggedIn = new BehaviorSubject<boolean>(false)
    loggedIn = this._loggedIn.asObservable();

    private _feed = new BehaviorSubject<boolean>(false)
    feed = this._feed.asObservable();

    private _ftoken = new BehaviorSubject<any>({})
    ftoken = this._ftoken.asObservable();

    constructor(){
    }

    changeUsername = (username: string)=>{
        this._username.next(username)
    }

    changeWallet = (wallet: number)=>{
        this._wallet.next(wallet)
    }

    toggleIsLoggedIn(isLoggedIn: boolean) {
        this._loggedIn.next(isLoggedIn)
    }

    toggleFeed(feedVisibility: boolean){
        this._feed.next(feedVisibility)
    }

    changeFtoken(ftoken: any){
        this._ftoken.next(ftoken)
    }
}
